import React, { useState, useEffect } from "react";
import Header from "../components/header";
import DividerBottom from "../components/divider-bottom";
import Footer from "../components/footer";

function Calendar() {

    const calendarURLs = {
        beavers: "https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=Europe%2FLondon&src=dTZuYmVma2o0ZDg0YWM4cTdkdHYybG1zdGdhMHNncXNAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%23006ddf",
        cubs: "https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=Europe%2FLondon&src=cnIwaTcwcWpqbjFhaHVmMmxzbnEyMGlnM2R1b2dnZXZAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%2323a950",
        scouts: "https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=Europe%2FLondon&src=MmlsanJvdDNmYjlyOWw4NnVlZTU0Mmoxajh1dHI3NWVAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%2300a794",
        all: "https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=Europe%2FLondon&src=dTZuYmVma2o0ZDg0YWM4cTdkdHYybG1zdGdhMHNncXNAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%23006ddf&src=cnIwaTcwcWpqbjFhaHVmMmxzbnEyMGlnM2R1b2dnZXZAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%2323a950&src=MmlsanJvdDNmYjlyOWw4NnVlZTU0Mmoxajh1dHI3NWVAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%2300a794&showCalendars=1"
    };

    const getMode = () => (window.innerWidth <= 768 ? "AGENDA" : "MONTH");

    const [selectedCalendar, setSelectedCalendar] = useState("all");
    const [calendarSrc, setCalendarSrc] = useState("");

    useEffect(() => {
        const mode = getMode();
        const url = calendarURLs[selectedCalendar];

        const finalURL = url.includes("mode=")
            ? url.replace(/mode=[^&]*/, `mode=${mode}`)
            : `${url}&mode=${mode}`;

        setCalendarSrc(finalURL);
    }, [selectedCalendar]);

    return (
        <>
            <Header />

            <main>
                <section id="calendar">
                    <h1>Upcoming Events</h1>

                    <div id="calendar-filters">
                        <button
                            data-calendar="beavers"
                            className={selectedCalendar === "beavers" ? "active" : ""}
                            onClick={() => setSelectedCalendar("beavers")}
                        >
                            Beavers
                        </button>

                        <button
                            data-calendar="cubs"
                            className={selectedCalendar === "cubs" ? "active" : ""}
                            onClick={() => setSelectedCalendar("cubs")}
                        >
                            Cubs
                        </button>

                        <button
                            data-calendar="scouts"
                            className={selectedCalendar === "scouts" ? "active" : ""}
                            onClick={() => setSelectedCalendar("scouts")}
                        >
                            Scouts
                        </button>

                        <button
                            data-calendar="all"
                            className={selectedCalendar === "all" ? "active" : ""}
                            onClick={() => setSelectedCalendar("all")}
                        >
                            All
                        </button>
                    </div>

                    <div id="calendar-container">
                        <iframe
                            id="calendar-frame"
                            src={calendarSrc}
                            style={{ border: "solid 1px #777" }}
                            width="100%"
                            height="800"
                            frameBorder="0"
                            scrolling="no"
                            title="Scout Calendar"
                        />
                    </div>
                </section>

                <DividerBottom />
            </main>

            <Footer />
        </>
    );
}

export default Calendar;